import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

// Routes where a "back" affordance makes no sense (entry points / own chrome).
const HIDDEN_EXACT = ["/", "/auth/login", "/auth/register", "/b2c/login", "/b2c/register"];
const HIDDEN_PREFIX = ["/superadmin"];

export default function BackButton() {
  const { t } = useLang();
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;

  // Back affordance is kept ONLY in the B2B partner space. It is removed on all
  // B2C and public pages per product decision.
  if (!path.startsWith("/b2b")) return null;
  if (HIDDEN_EXACT.includes(path)) return null;
  if (HIDDEN_PREFIX.some((p) => path.startsWith(p))) return null;

  // On the B2B dashboard a fixed 18rem sidebar sits on the left at lg+ — shift the
  // arrow into the content area there, and hide it below lg where the mobile top
  // bar already provides a hamburger menu.
  const posClass = "top-3 lg:left-[18.75rem] hidden lg:grid";

  const goBack = () => {
    // Always return to the previous page in the browser history (never force home).
    navigate(-1);
  };

  return (
    <button
      onClick={goBack}
      aria-label={t("hc.back")}
      title={t("hc.back")}
      data-testid="global-back-button"
      style={{ filter: "drop-shadow(0 1px 1px rgba(255,255,255,0.95)) drop-shadow(0 0 2px rgba(255,255,255,0.7))" }}
      className={`fixed ${posClass} z-[55] place-items-center h-9 w-9 rounded-full text-findo-navy/80 hover:text-findo-navy hover:bg-black/5 transition-colors`}
    >
      <ArrowLeft size={22} strokeWidth={2.5} />
    </button>
  );
}
